import React from 'react'
import {motion} from 'framer-motion';
//import global styles
import{
    FlexContainer,
    PaddingContainer,
    Heading,
    IconContainer,
    ParaText,
    BlueText,
    Text,
    Image,
    StyledDivider
} from '../styles/Global.styled'
import UCNLogo from '../assets/UCN_Logo.png';
//import myskills styles
import { SkillsCardContainter,SkillsCard } from '../styles/MySkills.styled'
import { FrontendSkills, BackendSkills, ToolsSkills, SoftSkills } from '../utils/Data'
import { fadeInLeftVariant,fadeInRightVariant, fadeInTopVariant} from '../utils/Variants';
const MySkills = () => {
  return (
    <PaddingContainer
        id='skills'
        top='15%'
        bottom='10%'
        left="8%"
        right="8%"
        tabletLeft="2%"
        tabletRight="2%"
        responsiveLeft='1rem'
        responsiveRight='1rem'
    >
        
       
        <FlexContainer fullWidthChild responsiveFlex responsiveDirection='column' gap='70px'>  
            {/** left section */}
           
            <motion.div  
                variants={fadeInLeftVariant} 
                initial='hidden' 
                whileInView='visible' 
                viewport={{ once: false, amount: 0.2 }}>
                <PaddingContainer bottom='20px'>
                     <Heading size='h4' align='left' >
                            <Text weight='bold'>Habilidades</Text>
                </Heading>
                <Heading size='h2' align='left' >
                      <Text weight='bold'> Mis<BlueText> Competencias</BlueText></Text> 
                </Heading>
               </PaddingContainer>

               <PaddingContainer top='5px' >
                
                    <ParaText>
                        Mi formación me permite adaptarme a los diferentes desafios que se me presentan, con una sólida base científica/matemática
                        tuve la oportunidad de aprender de las numerosas áreas ofrecidas por el sector técnológico, desde los Fundamentos de la Computación,
                        la Arquitectura de Computadores y Análisis de Algoritmos, hasta la Ciencia de Datos y el Desarrollo de Software.
                    </ParaText>
                    
                    <StyledDivider />
                  <Heading size='h4' align='left' >
                            <Text weight='bold'>Habilidades Blandas</Text>
                  </Heading>
                   <PaddingContainer   top='20px' bottom='10px' right='10px' left='10px'>
                <SkillsCardContainter>
                    {SoftSkills.map((skill) => (
                        <SkillsCard>
                            <IconContainer     size='3.1rem'  color={skill.color} >
                                {skill.icon}
                            </IconContainer>
                            <Heading as='h5'size='h5' align='center'>
                                {skill.tech}
                            </Heading>
                        </SkillsCard>
                    ))}
                </SkillsCardContainter>
                </PaddingContainer>
                  <PaddingContainer >

                                        <StyledDivider />

                  </PaddingContainer>

                    <PaddingContainer top='10px' >
                        <Heading size='h4' align='center' >
                                    <Text weight='bold'>  🎓 Estudios 🎓</Text>
                        </Heading >
                        <PaddingContainer top='10px' >
                            <PaddingContainer top='30px' bottom='20px'>
                                  <Image src={UCNLogo}  style={{position:'relative' ,display: 'block', margin: 'auto', }}/>
                            </PaddingContainer>
                            <Heading align='center'>
                            <ParaText>
                                <Text weight='bold'>Títulado de Ingeniería Civil en Computación e Informática.</Text>
                            </ParaText>
                            <ParaText>
                                Universidad Católica del Norte
                            </ParaText>
                             <ParaText>
                                Antofagasta, Chile.
                            </ParaText>
                            </Heading>
                        </PaddingContainer>
                    </PaddingContainer>
                    
                                                            <StyledDivider />

                    
                    
                </PaddingContainer>
            </motion.div>


            {   /** right section */}
             <FlexContainer direction='column' >
            <motion.div 
                variants={fadeInRightVariant} 
                initial='hidden' whileInView='visible' 
                viewport={{ once: false, amount: 0.2 }}>
            <PaddingContainer bottom='10px' top='50px'>


            <Heading  size='h4' align='center' > <Text weight='bold'> Backend ⚙️</Text></Heading>
            </PaddingContainer>

                <PaddingContainer   top='10px' bottom='50px' right='10px' left='10px'>
                <SkillsCardContainter>
                    {BackendSkills.map((skill) => (
                        <SkillsCard>
                            <IconContainer     size='3.1rem'  color={skill.color} >
                                {skill.icon}
                            </IconContainer>
                            <Heading as='h5'size='h5'>
                                {skill.tech}
                            </Heading>
                        </SkillsCard>
                    ))}
                </SkillsCardContainter>
                </PaddingContainer>

                <PaddingContainer bottom='10px' top='10px'>
                    <Heading  size='h4' align='center'> <Text weight='bold'>  Frontend ✏️ </Text></Heading>
                </PaddingContainer>

                <PaddingContainer top='10px' bottom='50px' right='10px' left='10px'>
                <SkillsCardContainter >
                
                    {FrontendSkills.map((skill) => (
                        <SkillsCard>
                            <IconContainer     size='3.1rem'  color={skill.color} >
                                {skill.icon}
                            </IconContainer>
                            <Heading as='h5'size='h5'>
                                {skill.tech}
                            </Heading>
                        </SkillsCard>
                    ))}
                </SkillsCardContainter>
                </PaddingContainer>

                 <PaddingContainer bottom='10px' top='10px'>
                    <Heading  size='h4' align='center'>  <Text weight='bold'>  Herramientas y DevOps  🔧 </Text> </Heading>
                </PaddingContainer>

                <PaddingContainer top='10px' bottom='10px' right='10px' left='10px'>
                <SkillsCardContainter >
                
                    {ToolsSkills.map((skill) => (
                        <SkillsCard>
                            <IconContainer     size='3.1rem'  color={skill.color} >
                                {skill.icon}
                            </IconContainer>
                            <Heading as='h5'size='h5'>
                                {skill.tech}
                            </Heading>
                        </SkillsCard>
                    ))}
                </SkillsCardContainter>
                </PaddingContainer>

            </motion.div>
            </FlexContainer>
        </FlexContainer>


        

    </PaddingContainer>
  )
}

export default MySkills